import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  headersFluxosProaqs as headers,
  valoresExibidosOffCanvasFluxoProaq as valoresExibidos,
} from './auxiliarFluxosProaq';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import Modal from '../../../../components/Modal';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import BolinhaTabelaStatus from '../../../../components/bolinhaTabelaStatus';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { EnumOption, TipoModalidade } from '../../../../modules/types/types';
import { useUnidadeDAF } from '../../../../services/enum/useUnidadeDaf';
import { getAllFluxoProaq } from '../../../../services/fluxo/fluxoProaqService';
import { getAllTipoModalidade } from '../../../../services/processosAquisitivos/proaqService';
import { formataNomeMeioSiglas, formatDate } from '../../../../utils/functions';
import { swalAttention } from '../../../../utils/swal';

const FluxosProaq: React.FC = () => {
  const user = getUser();
  const userUnidadeDaf = user.unidade;

  const navigate = useNavigate();

  const unidadeDAF = useUnidadeDAF();
  // const modalidade = useProaqModAquisicao();

  //Dados do coordenacao
  const [data, setData] = useState<any[]>([]);
  const [formFluxoProaq, setFormFluxoProaq] = useState({
    nomeModelo: '',
    modalidade: 0,
    coordenacao: 0,
    status: 1,
  });
  const [tipoModalidadeData, setTipoModalidadeData] = useState<
    TipoModalidade[]
  >([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [statusInserir, setStatusInserir] = useState<boolean>(true);
  const [showModal, setShowModal] = useState<boolean>(false);
  const tituloModal = 'Novo Fluxo de Processo Aquisitivo';
  const iconeModal = 'document';

  // Buscar dados
  useEffect(() => {
    fetchData();
  }, []);

  const tipoModalidadeOptions: EnumOption[] = [
    { value: '0', label: 'Não informado' },
    ...tipoModalidadeData.map((item: TipoModalidade) => ({
      value: item.id.toString(),
      label: item.nomeTipoModalidade,
    })),
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      const registros = await getAllFluxoProaq();
      setData(registros);
      const tipoModalidadeData = await getAllTipoModalidade();
      setTipoModalidadeData(tipoModalidadeData);
    } catch (error: any) {
      setError(
        error.response?.data?.message ||
          'Erro ao buscar FluxoProaq. Tente novamente mais tarde.',
      );
      console.error('Erro ao buscar FluxoProaq:', error);
    } finally {
      setLoading(false);
    }
  };

  // Regras
  useEffect(() => {
    if (
      formFluxoProaq.coordenacao === 0 ||
      formFluxoProaq.modalidade === 0 ||
      formFluxoProaq.nomeModelo === ''
    ) {
      setStatusInserir(false);
    } else {
      setStatusInserir(true);
    }
  }, [formFluxoProaq]);

  useEffect(() => {
    setFormFluxoProaq({ ...formFluxoProaq, coordenacao: userUnidadeDaf });
  }, [userUnidadeDaf]);

  // Tabela
  const tableDataFluxoProaq = Array.isArray(data)
    ? data.map((item) => ({
        id: item.id,
        status: (
          <BolinhaTabelaStatus status={item.status === 'S' ? 'S' : 'N'} />
        ),
        modalidade: tipoModalidadeOptions[item.modalidade]?.label,
        coordenacao: unidadeDAF[item.coordenacao].label,
        nFases: item.fluxoProaqFases?.length || 'Sem fases cadastradas',
        nomeModelo: item.nomeModelo,
        nProaq: item.nProaq,
      }))
    : [];

  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    status: item.status === 'S' ? 'Ativo' : 'Inativo',
    modalidade: tipoModalidadeOptions[item.modalidade]?.label,
    coordenacao: unidadeDAF[item.coordenacao].label,
    nFases: item.fluxoProaqFases?.length || 'Sem fases cadastradas',
    nomeModelo: item.nomeModelo,
    separadorObservacoes: '',
    observacoes: item.observacoes,
  }));

  // Funções Handle
  const handleClearModal = () => {
    setFormFluxoProaq({
      ...formFluxoProaq,
      nomeModelo: '',
      modalidade: 0,
    });
  };

  const handleShowModal = () => {
    handleClearModal();

    setShowModal((show) => !show);
  };

  // Abre o modal para inserir um novo Fluxo Proaq
  const handleClickInserir = () => {
    handleClearModal();
    setShowModal(true);
  };

  const handleClickModalInserir = () => {
    const { modalidade, coordenacao, status } = formFluxoProaq;

    if (modalidade === 0) {
      swalAttention('Informe a <b>Modalidade de Aquisição</b>!');
      return;
    }

    if (coordenacao === 0) {
      swalAttention('Informe a <b>Unidade DAF</b>!');
      return;
    }

    // Apenas bloqueia se o novo modelo for status 'Ativo'
    if (Number(status) === 1) {
      const modeloAtivoExistente = data.find(
        (item) =>
          item.modalidade === modalidade &&
          item.coordenacao === coordenacao &&
          item.status === 'S',
      );

      if (modeloAtivoExistente) {
        swalAttention(
          'Já existe um <b>modelo ativo</b> para essa <b>Modalidade de Aquisição</b> e <b>Unidade DAF</b>.',
        );
        return;
      }
    }

    navigate('fluxoproaq/ficha/dadosgerais', { state: { formFluxoProaq } });
  };

  const handleOnRowClick = (id: string) => {
    if (!id) {
      return;
    }
    navigate(`fluxoproaq/ficha/${id}/dadosgerais`);
  };

  const handleChangeModal = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);

    setFormFluxoProaq((prev) => {
      const updatedForm = { ...prev, [name]: value };

      if (name === 'modalidade' || name === 'coordenacao') {
        const updateFormSelect = { ...prev, [name]: newValue };
        return updateFormSelect;
      }

      return updatedForm;
    });
  };

  return (
    <>
      <ContainerConteudo>
        <Tabela
          headers={headers}
          dataTable={tableDataFluxoProaq}
          dataOffCanvas={offCanvasData}
          onRowClick={handleOnRowClick}
          displayValues={valoresExibidos}
          showPagination={false}
        />
      </ContainerConteudo>
      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          // onClickDownload
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>

      {showModal && (
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
          modalSize="medio"
          size="lg"
        >
          <WorkspaceFicha>
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="nomeModelo"
                  name="nomeModelo"
                  value={formFluxoProaq.nomeModelo}
                  onChange={handleChangeModal}
                  label="Nome do Modelo"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="40%">
                <Input
                  id="coordenacao"
                  name="coordenacao"
                  value={unidadeDAF[formFluxoProaq.coordenacao].label}
                  onChange={handleChangeModal}
                  label="Coordenação"
                  // disabled={papelUsuario === '1' ? false : true}
                  disabled
                />
              </CustomCol>
              <CustomCol width="60%">
                <SelectInput
                  name="modalidade"
                  value={formFluxoProaq.modalidade}
                  options={tipoModalidadeOptions}
                  onChange={handleChangeModal}
                  label="Mod. Aquisição"
                  disabled={formFluxoProaq.nomeModelo.length > 0 ? false : true}
                />
              </CustomCol>
            </CustomRow>
            <BarraInferiorBotoes>
              <WorkspaceBotoes
                inserir
                inserirDisabled={!statusInserir}
                onClickInserir={handleClickModalInserir}
                cancelar
                onClickCancelar={handleShowModal}
              />
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>
      )}
    </>
  );
};

export default FluxosProaq;
